import { render } from "./LoginForm.vue?vue&type=template&id=ca86c608&scoped=true&ts=true"
import script from "./LoginForm.ts?vue&type=script&lang=ts&external"
export * from "./LoginForm.ts?vue&type=script&lang=ts&external"

import "./LoginForm.scss?vue&type=style&index=0&id=ca86c608&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca86c608"]])

export default __exports__